import apiClient from './client';
import type { PlatformAnalyticsData, PlatformPeriod } from '../types/platformAnalytics';

export async function getPlatformAnalytics(
  period: PlatformPeriod = '30d',
): Promise<PlatformAnalyticsData> {
  const { data } = await apiClient.get<PlatformAnalyticsData>(
    '/admin/platform-analytics/',
    { params: { period } },
  );
  return data;
}
